/**
 * Compute the ordered list of active filter keys for the bar.
 *
 * Rules (preserve the current "empty chip before value" UX):
 * - Keys listed in `filtersOrder` come first, in that order.
 * - Empty-shell keys (value `""`, just added) still appear.
 * - Cleared keys (value `undefined`) drop out.
 * - Keys present but not in `filtersOrder` come last, in object order.
 */
export function computeActiveKeys(
  filters: Record<string, unknown> | undefined,
  filtersOrder: string[] | undefined,
): string[] {
  const present = Object.keys(filters ?? {}).filter(
    (key) => filters?.[key] !== undefined,
  );
  const order = filtersOrder ?? [];
  const ordered = order.filter((key) => present.includes(key));
  const rest = present.filter((key) => !order.includes(key));
  return [...ordered, ...rest];
}
